import React, {   FunctionComponent as FC } from 'react';
import { Switch } from 'antd';

import DownloadButton from '../../../common/DownloadButton';
import './index.scss';


interface ChartUnitProps {
    title: string;
    isTemporalVisible: boolean;
    toggleTemporalView: () => void;
    chart: React.ReactNode;
}

const ChartUnit: FC<ChartUnitProps> = (props) => {
    const { title, isTemporalVisible, toggleTemporalView, chart } = props;

    // TODO: download the chart
    const handleDownload = () => {
      console.log('download');
    }

    return (
        <div className="chart-part">
            <div className="title-switch-part">
              <div className="title">{title}</div>
              {/* <DownloadButton handleDownload={handleDownload} /> */}
              {/* <div className="temporal-switch">
                <div className="temporal-text">Temporal</div>
                <Switch checked={isTemporalVisible} size="small" onChange={toggleTemporalView} />
              </div> */}
            </div>
              <div style={{ position: 'relative' }}>
                {isTemporalVisible ? (
                  <div className="temporal-view" style={{ position: 'absolute', height: "80px", width: "324px"}}>
                    {/* Temporal View */}
                    This is the Temporal View.
                  </div>
                ) : (
                  <div className="barchart-view" style={{ position: 'absolute', height: "80px", width: "324px" }}>
                    {/* Barchart View */}
                    {chart}
                  </div>
                )}
              </div>
        </div>
    )
};

export default ChartUnit;